@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.DraggableList {
  @extend %form-control-font;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  align-self: stretch;
  overflow-y: auto;
  margin: -2px -2px 0;
  padding: 2px;

  >div {
    width: 100%;
  }
}

.DraggableListItem {
  @extend %form-control-font;

  padding: 8px 0;
  border: 1px solid $theme-color-borders;
  border-radius: 6px;
  background-color: $theme-color-background;
  margin-top: 2px;

  &.isSelected {
    background-color: $theme-draggable-list-selected-background;
  }
}

.DraggableListHeader {
  @extend %form-control-label-font;

  padding: 8px 10px;
  border-top: 1px solid $theme-color-borders;
  border-bottom: 1px solid $theme-color-borders;
  background-color: $theme-color-sub-background;
}
